import React from 'react';
//import { Link } from 'react-router-dom';
import styled from 'styled-components'; // package to define css class
//import $ from 'jquery'; // package to run jQuery
//import { Button } from 'bootstrap';
//import appstoreQRCode from '../images/qrcode/appstoreQRCode.png';
//import googleplayQRCode from '../images/qrcode/androidQRCode.png';
import Popup from 'reactjs-popup';
import './AndroidModal.css';

const Col6 = styled.div`
  width: 100%;
  display: inline-block;
  vertical-align: top;
  text-align: middle;
`;

function AndroidModal({ Ref }) {
    function toDownloadAppAndroid() {
        window.open('https://play.google.com/store/apps/details?id=com.vivableeraw', "_blank");
        //window.location.href = 'https://play.google.com/store/apps/details?id=com.vivableeraw';
    }
    return (
        <div>
            <Popup
                ref={Ref}
                modal
                nested
                repositionOnResize
                contentStyle={{ maxWidth: '400px', borderRadius: '25px' }}
            >
                {close => (
                    <div className="amodal">
                        <button className="close" onClick={close}>
                            &times;
                        </button>
                        <Col6>
                            {/* <h1><center>Google Play</center></h1> */}
                            <img
                                style={{ width: '70%' }}
                                src={require('../images/qrcode/androidQRCode.png')}
                                className="center"
                                alt="googleplay qrcode"
                            ></img>
                            <img
                                onClick={toDownloadAppAndroid}
                                style={{ width: '60%', cursor: 'pointer' }}
                                //style={{ width: '170px', cursor: 'pointer' }}
                                src={require('../images/general/google_play.png')}
                                className="center"
                                alt="googleplay download"
                            ></img>
                        </Col6>
                    </div>
                )}
            </Popup>
        </div>
    );
}

export default AndroidModal;